(() => {
  'use strict';
  if (!document.body?.classList.contains('kks-bougie')) return;
  // Shopify Forms campaign observed on this store. Do not change other embeds.
  const hostSelector = 'shopify-forms-embed#app-embed-container-6818';
  const mutedAttribute = 'data-kks-promo-muted';
  const styleId = 'kks-promo-collision-style';
  let host, root, embedObserver, frame = 0, retry, retries = 0;
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const state = value => {
    if (host.dataset.kksPromoState !== value) host.dataset.kksPromoState = value;
  };
  const offset = value => {
    const text = `${value}px`;
    if (host.style.getPropertyValue('--kks-promo-bottom') !== text) {
      host.style.setProperty('--kks-promo-bottom', text);
    }
    // Do not override the campaign's native placement when no sticky bar exists.
    host.toggleAttribute('data-kks-promo-offset', value > 0);
  };
  function watch(next) {
    if (host !== next || root !== next.shadowRoot) {
      embedObserver?.disconnect();
      host = next;
      root = next.shadowRoot;
      if (!root) return;
      embedObserver = new MutationObserver(schedule);
      embedObserver.observe(root, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['data-current-step']
      });
      // The app can replace its own inline host style. Reapply only our offset.
      embedObserver.observe(host, {attributes: true, attributeFilter: ['style']});
    }
    if (root && !root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        :host([data-kks-promo-offset]) #app-embed[data-current-step="tease"] {
          bottom:var(--kks-promo-bottom,0px)!important;
        }
        :host([${mutedAttribute}]) #app-embed[data-current-step="tease"] {
          display:none!important;
        }`;
      root.appendChild(style);
    }
  }
  const intersects = (a, b) => b.width > 0 && b.height > 0 &&
    a.left < b.right + 8 && a.right > b.left - 8 &&
    a.top < b.bottom + 8 && a.bottom > b.top - 8;
  function update() {
    frame = 0;
    const next = document.querySelector(hostSelector);
    if (!next) return;
    watch(next);
    if (!root) {
      if (!retry && retries++ < 40) retry = setTimeout(() => {
        retry = null; schedule();
      }, 250);
      return;
    }
    if (retry) { clearTimeout(retry); retry = null; }
    const teaser = root.querySelector('[data-testid="form-teaser"]');
    const teaserRoot = root.querySelector('#app-embed[data-current-step="tease"]');
    if (!teaser || !teaserRoot) {
      host.removeAttribute(mutedAttribute); offset(0); state('form-or-dismissed'); return;
    }
    const sticky = document.getElementById('sticky-purchase');
    const stickyRect = sticky && !sticky.hidden ? sticky.getBoundingClientRect() : null;
    const stickyVisible = stickyRect?.height > 0 && stickyRect.width > 0 &&
      stickyRect.top < innerHeight && stickyRect.bottom > 0;
    offset(stickyVisible ? Math.ceil(innerHeight - stickyRect.top) + 12 : 0);

    // Measure the app-owned teaser in its candidate position. Synchronous
    // re-hiding happens before paint, without changing app state or dismissal.
    host.removeAttribute(mutedAttribute);
    const rect = teaser.getBoundingClientRect();
    const menu = document.getElementById('mobile-nav');
    const overlayOpen = !!document.querySelector(
      'cart-drawer[open],cart-drawer[active],#image-dialog[open]'
    ) || (menu && !menu.hidden);
    const panel = document.querySelector('.kks-b-scope .purchase-panel');
    const focused = document.activeElement;
    const editingPurchase = panel?.contains(focused) &&
      /^(INPUT|SELECT|TEXTAREA)$/.test(focused?.tagName);
    const targets = document.querySelectorAll(
      '.kks-b-scope .purchase-panel,.kks-b-scope a,.kks-b-scope button,' +
      '.kks-b-scope input,.kks-b-scope select,.kks-b-scope summary,' +
      '.kks-b-scope footer'
    );
    const collision = rect.width > 0 &&
      [...targets].some(el => intersects(rect, el.getBoundingClientRect()));
    const suppress = overlayOpen || editingPurchase || collision;
    host.toggleAttribute(mutedAttribute, !!suppress);
    state(overlayOpen ? 'overlay' : editingPurchase || collision ? 'controls' : 'clear');
  }
  // Detect late app insertion and native cart/menu/sticky state changes.
  const documentObserver = new MutationObserver(schedule);
  documentObserver.observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['open', 'active', 'hidden', 'aria-expanded']
  });
  addEventListener('scroll', schedule, {passive: true});
  addEventListener('resize', schedule, {passive: true});
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('scroll', schedule, {passive: true});
  const resizeObserver = new ResizeObserver(schedule);
  for (const selector of ['.purchase-panel', '#sticky-purchase']) {
    const el = document.querySelector(`.kks-b-scope ${selector}`);
    if (el) resizeObserver.observe(el);
  }
  document.fonts?.ready.then(schedule);
  customElements.whenDefined('shopify-forms-embed').then(schedule);
  schedule();
})();
